// extracted by mini-css-extract-plugin
module.exports = {"container":"_6eb00b8e53--container--2f_pv","header":"_6eb00b8e53--header--1fHwf","text":"_6eb00b8e53--text--2A0yC"};